import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=d74927b2&scoped=true&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&id=d74927b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74927b2",
  null
  
)

export default component.exports